import InAppMessage from "./models/in-app-message.js";
import r from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import { logger as E } from "../../shared-lib/index.js";
import se from "./in-app-message-manager-factory.js";
export function deferInAppMessage(e) {
  if (r.rr()) return e instanceof ControlMessage ? (E.info("Not deferring since this is a ControlMessage."), !1) : e instanceof InAppMessage ? se.ea().Ee(e) : (E.info("Not an instance of InAppMessage, ignoring."), !1);
}